<template>
    <div class="animation-hook"/>
</template>

<script>
    import { intersectionObserverMixin, uuidMixin } from '@dreipol/vue-ui/src/mixins';
    import { elementOffsetTop } from 'bianco.viewport';
    import { mapActions, mapState } from 'vuex';

    export default {
        mixins: [uuidMixin, intersectionObserverMixin],
        props: {
            rotation: {
                type: Object,
                required: true,
            },
            position: {
                type: Object,
                default() {
                    return {
                        x: 0,
                        y: 0,
                        z: 0,
                    };
                },
            },
        },
        computed: {
            ...mapState('viewport', ['height', 'width']),
        },
        methods: {
            ...mapActions('animation-hooks', ['activateHook', 'deactivateHook', 'updateHook', 'registerHook']),
            getHookProperties() {
                return { id: this.uuid, offset: elementOffsetTop(this.$el), rotation: this.rotation, position: this.position };
            },
            onResize() {
                this.updateHook(this.getHookProperties());
            },
            onIntersect(isInThreshold, entry) {
                if (entry.isIntersecting) {
                    this.activateHook({ id: this.uuid });
                } else {
                    this.deactivateHook({ id: this.uuid });
                }
            },
        },
        watch: {
            height() {
                this.onResize();
            },
            width() {
                this.onResize();
            },
        },
        mounted() {
            this.registerHook(this.getHookProperties());
            this.registerObserver(this.$el);
        },
    };
</script>
